module.exports = __webpack_public_path__ + "static/media/msparcs.9c50352b.png";